// Inventory panel — full desk surface for manufacturing + purchasing seats.
import { ManufacturingInventoryDeskPanel } from "./ManufacturingInventoryDeskPanel";

export function ManufacturingInventoryPanel({
  onOpenInventoryCount,
  onOpenPurchasing,
}: {
  /** Jump to Production → Inventory count (materials MIC / recipe count). */
  onOpenInventoryCount?: () => void;
  /** Jump to Production → Purchasing (POs + invoice receipts). */
  onOpenPurchasing?: () => void;
} = {}) {
  return (
    <ManufacturingInventoryDeskPanel
      onOpenInventoryCount={onOpenInventoryCount}
      onOpenPurchasing={onOpenPurchasing}
    />
  );
}
